<template>
  <div class="app-container" style="padding:30px 100px;">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="100px">
      <el-form-item label="企业全称:">{{detail.tenantFullName}}</el-form-item>
      <el-form-item label="联系人姓名:">{{detail.linkNickName}}</el-form-item>
      <el-form-item label="手机号:">{{detail.linkTel}}</el-form-item>
      <el-form-item label="套餐:" prop="packageId">
        <el-select v-model="data.packageId" placeholder="请选择套餐" clearable style="width:500px" @change="changePackage">
          <el-option
            v-for="item in packageOptions"
            :key="item.packageId"
            :label="item.packageName"
            :value="item.packageId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="单价:">
        <template v-if="selectPackage.price != null">
          {{selectPackage.price ? amountFormat(selectPackage.price) : 0}}元
        </template>
      </el-form-item>
      <el-form-item label="套餐有效期:">
        <template v-if="selectPackage.price != null">
          {{selectPackage.validity}}个月
        </template>
      </el-form-item>
      <el-form-item label="数量:" prop="buyCount">
        <el-input
          v-model.number="data.buyCount"
          oninput="value=value.replace(/[^\d.]/g,'')"
          style="width:500px"
          placeholder="请输入数量"
          @change="changeBuyCount"
        ></el-input>
      </el-form-item>
      <el-form-item label="合计有效期:" prop="modules">
        <template v-if="selectPackage.validity && data.buyCount">
          {{selectPackage.validity*data.buyCount}}个月
        </template>
      </el-form-item>
      <el-form-item label="合计金额:" prop="modules">
        <template v-if="(selectPackage.price || selectPackage.price == 0) && data.buyCount">
          {{selectPackage.price == 0 ? 0 : amountFormat(selectPackage.price*data.buyCount)}}元
        </template>
      </el-form-item>
      <el-form-item label="生效时间:" prop="validityStartTime">
        <el-date-picker
          v-model="data.validityStartTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期"
          style="width:500px"
        ></el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="到期时间:" prop="term"></el-form-item> -->
      <el-form-item label="收费记录:" prop="term">
        <p>
          <el-button type="primary" @click="handleAdd">添加</el-button>
        </p>
        <el-table v-loading="loading" :data="data.feeRecordList">
          <el-table-column label="日期" min-width="150" align="center" prop="feeTime" />
          <el-table-column label="收费方式" min-width="60" align="center" prop="chargeType" />
          <el-table-column label="金额（元）" width="120" align="center">
            <template slot-scope="scope">
              {{scope.row.feeAmount ? amountFormat(scope.row.feeAmount) : 0}}
            </template>
          </el-table-column>
          <el-table-column label="备注" min-width="90" align="center" prop="remark" />
          <el-table-column label="操作" min-width="70" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="handleDelete(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="备注:" prop="remark">
        <el-input
          type="textarea"
          style="width:500px"
          :autosize="{ minRows: 3, maxRows: 5}"
          :maxlength="1000"
          show-word-limit
          v-model="data.remark"
          placeholder="请输入"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确认</el-button>
      </el-form-item>
    </el-form>
    <AddCollectionRecordDialog ref="addTenantDialogRef" @success="feeRecordList"></AddCollectionRecordDialog>
  </div>
</template>
<script>
const moduleOptions = ["上海", "北京", "广州", "深圳"];
import AddCollectionRecordDialog from "../components/addCollectionRecordDialog.vue";
import { queryTenantDetail, queryListPackage, saveBuyPackage, feeRecordList } from "@/api/saas/package";
import { amountFormat } from "@/utils/index";

export default {
  components: {
    AddCollectionRecordDialog
  },
  data() {
    return {
      amountFormat,
      packageOptions: [],
      detail: {},
      selectPackage: {},
      loading: false,
      dataList: [],
      total: 0,
      rules: {
        package: [
          { required: true, message: "请选择选择套餐", trigger: "change" }
        ],
        buyCount: [
          { required: true, message: "请输入数量", trigger: "change" }
        ],
        validityStartTime: [
          { required: true, message: "请选择生效日期", trigger: "change" }
        ]
      },
      data: {
        buyCount: null,
        package: null,
        packageId: null,
        validityStartTime: null,
        remark: null,
        tenantId: null,
        feeRecordList: [] // 收费记录
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10
      }
    };
  },
  watch: {
    'data.buyCount' (val) {
      if (val) {
        console.log('val--', val)

      }
    }
  },
  created() {
    this.data.tenantId = this.$route.query.tenantId;
    this.queryTenantDetail(); // 查询租户详情
    this.queryListPackage() // 查询套餐列表
  },
  methods: {
    handleAdd() {
      this.$refs.addTenantDialogRef.open();
    },
    changePackage(e) {
      this.packageOptions.map(item => {
        if(item.packageId === e) {
          this.selectPackage = item
        }
      })
      console.log('selectPackage', this.selectPackage)
      // this.selectPackage = e
      // this.data.packageId = e.packageId
    },
    queryTenantDetail() {
      queryTenantDetail({
        tenantId: this.data.tenantId
      })
        .then(response => {
          this.detail = response.data || {};
        })
        .catch(error => {
          this.loading = false;
        });
    },
    // 添加收费记录
    feeRecordList(row) {
      console.log('row', row)
      this.data.feeRecordList.push(row)
    },
    // 删除收费记录
    handleDelete(row, index) {
      let that = this
        this.$confirm('是否确认删除该条收费记录?', "警告", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function() {
          that.data.feeRecordList.splice(index,1)
        }).then(() => {
        })
    },
    queryListPackage() {
      queryListPackage({
        pageNum: 1,
        pageSize: 100000,
        status: 1
      })
        .then(response => {
          this.packageOptions = response.rows || [];
        })
        .catch(error => {
          this.loading = false;
        });
    },
    confirm() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          saveBuyPackage(this.data).then(response => {
            loading.close();
            this.msgSuccess("操作成功");
            this.$router.go(-1)
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    cancel() {
      this.$router.go(-1)
    },
    changeBuyCount(e){
      this.data.buyCount = e
    }
  }
};
</script>